module.exports = __webpack_public_path__ + "img/speaker-2-1.9226be66.jpg";